import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e10cef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "work" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Work Experience", -1))
const _hoisted_3 = { class: "experiences" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "metadata" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_vue = _resolveComponent("icon-vue")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_icon_vue, {
      color: 'green',
      icon: 'science'
    }),
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experiences, (exp) => {
        return (_openBlock(), _createElementBlock("article", {
          key: exp.id,
          class: _normalizeClass([...exp.tags, 'work']),
          id: exp.id
        }, [
          _createElementVNode("h3", null, _toDisplayString(exp.company), 1),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("h4", null, _toDisplayString(exp.role), 1),
            (exp.start != exp.end)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6, _toDisplayString(_ctx.dateFromString(exp.start)) + " to " + _toDisplayString(_ctx.dateFromString(exp.end)), 1))
              : (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(_ctx.dateFromString(exp.start)), 1))
          ]),
          _createElementVNode("p", {
            class: "description",
            innerHTML: _ctx.markdown(exp.description)
          }, null, 8, _hoisted_8)
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}